import observer from 'saddlebag-observer';
const trackEventFn = events => {
  events.forEach(event => {
    observer.publish(...Object.values(event));
  });
};
export { trackEventFn };